import {createRouter, createWebHistory} from 'vue-router';
import Homepage from '@/components/views/Homepage.vue';
import AccidentsView from '@/components/views/layers/AccidentsView.vue';
import CrimesView from '@/components/views/layers/CrimesView.vue';
import SocialAndCommercialVitalityView from '@/components/views/layers/SocialAndCommercialVitalityView.vue';
import UrbanGreeneryAndAirQualityView from '@/components/views/layers/UrbanGreeneryAndAirQualityView.vue';
import HumanPerceptionReport from '@/components/views/layers/HumanPerceptionReport.vue';
import HumanPerceptionView from '@/components/views/layers/HumanPerceptionView.vue';
import CyberSocialSecurityView from "@/components/views/layers/CyberSocialSecurityView.vue";

const routes = [
    {
        path: '/',
        component: Homepage,
    },
    {
        path: '/accidents',
        component: AccidentsView,
    },
    {
        path: '/crimes',
        component: CrimesView,
    },
    {
        path: '/social_and_commercial_vitality',
        component: SocialAndCommercialVitalityView,

    },
    {
        path: '/urban_greenery_and_air_quality',
        component: UrbanGreeneryAndAirQualityView,

    },
    {
        path: '/human_perception/report',
        component: HumanPerceptionReport,

    },
    {
        path: '/human_perception',
        component: HumanPerceptionView,

    },
    {
        path: '/cyber_social_security',
        component: CyberSocialSecurityView,

    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
